import { Box } from '@mui/material';
import React from 'react';
import { TopToolbar, usePermissions } from 'react-admin';
import { BackButton } from '../../../../components/shared/BackButton';
import { PUMPS_INDEX_URL } from '../../../../core/constants/url.constants';
import { PrivilegeType } from '../../../../core/models/privileges/privilegeType';
import { some } from '../../../../core/utils/collection-utils';
import { PumpsSpeedCreateButton } from './PumpsSpeedCreateButton';
import { PumpsSpeedExportButton } from './PumpsSpeedExportButton';

export const PumpsSpeedListActions = () => {
  const { permissions } = usePermissions();
  return (
    <TopToolbar>
      <BackButton to={PUMPS_INDEX_URL} />
      <Box sx={{ display: 'flex', gap: 1 }}>
        {some([PrivilegeType.MANAGE_PUMPS], permissions) && (
          <PumpsSpeedCreateButton />
        )}
        <PumpsSpeedExportButton />
      </Box>
    </TopToolbar>
  );
};
